import {
  Compiler,
  Inject,
  Injectable,
  Injector,
  NgModuleFactory,
  Optional,
} from '@angular/core';
import { IThemeLoaderConfig, THEME_LOADER } from './theme-config';

@Injectable({ providedIn: 'root' })
export class ThemeLoaderService {
  constructor(
    private injector: Injector,
    @Optional() @Inject(THEME_LOADER) private themeLoader: IThemeLoaderConfig[],
    @Optional() private compiler: Compiler
  ) {}

  public async load(theme: string): Promise<boolean> {
    const loader = this.themeLoader?.find((item) => item.theme === theme);

    if (loader) {
      const factory = await loader.load();
      const moduleRef = await this.loadModuleFactory(factory);
      moduleRef.create(this.injector);
      return true;
    }

    return false;
  }

  private async loadModuleFactory(moduleOrFactory: any) {
    if (moduleOrFactory instanceof NgModuleFactory) {
      return moduleOrFactory;
    } else {
      // When developing then NgModule needs to compiled. This goes away with prod build
      return await this.compiler.compileModuleAsync(moduleOrFactory);
    }
  }
}
